document.addEventListener('DOMContentLoaded', () => {
  const requestedProduct = new URLSearchParams(location.search).get('product');
  const customDescription = document.querySelector('.felt-inquiry-form textarea[name="contact[description]"]');
  if (requestedProduct && customDescription && !customDescription.value) customDescription.value = 'Custom colors for: ' + requestedProduct.slice(0, 250);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
      const variant = data?.variant;
      const image = document.querySelector('[data-festive-selected-image]');
      const caption = document.querySelector('[data-festive-selected-caption]');
      const source = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
      if (image && source) { image.removeAttribute('srcset'); image.src = source; image.alt = 'Complete garland set in ' + variant.title; }
      if (caption && variant) caption.textContent = 'Complete set · ' + variant.title;
    });
  }
  document.querySelectorAll('.festive-mobile-nav nav a').forEach(link => link.addEventListener('click', () => { link.closest('details').open = false; }));
});
